import { makeAutoObservable } from "mobx";
import CanvasService from "../Services/CanvasService";

class CanvasStore {
  canvasData: {
    canvasID: number;
    frameType: string;
    customizeProperties: string;
    uploadID: number;
    canvasProjectName?: string;
    canvasProjectDesc?: string;
  } | null = null;
  productId: number | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setCanvasData(
    canvasData: { frameType: string; customizeProperties: string; uploadID: number,canvasID: number },
    productId: number
  ) {
    this.canvasData = canvasData;
    this.productId = productId;
  }

  // Async method to call CreateCanvas from CanvasService
  async createCanvas( canvasData: { frameType: string; customizeProperties: string; uploadID: number; canvasProjectName?: string; canvasProjectDesc?: string },
    productId: number) {
    try {
      if (canvasData && productId !== null) {
        const response = await CanvasService.CreateCanvas(productId, canvasData);
        console.log(response);
        return response;        
      } else {
        console.error("Canvas data or product ID is missing");
      }
    } catch (error) {
      console.error("Failed to create canvas:", error);
    }
  }

    // Async method to call CreateCanvas from CanvasService
    async updateCanvas( canvasData: { frameType: string; customizeProperties: string; uploadID: number; canvasProjectName?: string; canvasProjectDesc?: string },
      productId: number, canvasID: number) {
      try {
        if (canvasData && productId !== null && canvasID !== null) {
          console.log(productId, canvasData, canvasID);
          const response = await CanvasService.UpdateCanvas(productId, canvasData, canvasID);
          console.log(productId +"updateCanvas");
          return response;        
        } else {
          console.error("Canvas data or product ID is missing");
        }
      } catch (error) {
        console.error("Failed to create canvas:", error);
      }
    }
}


const canvasStore = new CanvasStore();
export default canvasStore;
